type TransformSetting = NonNullable<Ya.Rum.LogErrorSettings['transform']>

export const enum LOAD_ERROR_MSG {
  _ = 'load error',
  IMG = 'IMG load error',
  SCRIPT = 'SCRIPT load error',
  LINK = 'LINK load error',
}

export type ProcessingError = Exclude<ReturnType<ErrorProcessor>, false>

export type ErrorProcessor = (error: Parameters<TransformSetting>[0], scope: ErrorScope) => ReturnType<TransformSetting>

export type LikeError = {
  message?: string
  originalMessage?: string
}

export type ErrorScope = {
  updateError: (data: Partial<ProcessingError>) => ProcessingError
}
